import React, { useState } from 'react';
import { resolveImageSrc } from '../utils/image';

const BrandLogo = ({ logoText, logoImage, alt, className = '', textClassName = '' }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const imageSrc = resolveImageSrc(logoImage);

  if (!imageSrc || imageFailed) {
    return <span className={textClassName}>{logoText}</span>;
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      onError={() => setImageFailed(true)}
    />
  );
};

export default BrandLogo;
